/*
 * @Author: etong
 * @Date: 2021-06-30 14:15:44
 * @LastEditTime: 2021-08-09 16:48:51
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\components\JJForm\index.js
 * Think first, Program later
 */
import Vue from 'vue'
import Form from './form'
import Item from './item'
import JJnoInFormItem from './noInFormItem'
import InputNumber from './input-number'

Vue.component('input-number', InputNumber)
Vue.component('jj-form', Form)
Vue.component('jj-form-item', Item)
Vue.component('jj-form-no-item', JJnoInFormItem)
